import React from "react";
import { Drawer } from "vaul";
import { PriceAlertConfigFormContent } from "./PriceAlertConfigForm";
import {
  PriceAlertConfigData,
  CreatePriceAlertConfigPayload,
  UpdatePriceAlertConfigPayload,
} from "@/api/price-alerts";

interface PriceAlertConfigDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  config?: PriceAlertConfigData | null;
  onSubmit: (payload: CreatePriceAlertConfigPayload | UpdatePriceAlertConfigPayload) => void;
  isLoading?: boolean;
}

export const PriceAlertConfigDrawer: React.FC<PriceAlertConfigDrawerProps> = ({
  open,
  onOpenChange,
  config,
  onSubmit,
  isLoading,
}) => {
  const isEdit = !!config;

  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange} repositionInputs={false}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/80 z-[120]" />
        <Drawer.Content className="bg-[#1a1b20] flex rounded-t-xl flex-col fixed bottom-0 left-0 right-0 max-h-[90vh] z-[121]">
          <div className="px-4 border-b border-gray-500/30 pb-3 pt-2 sticky top-0 bg-secondary z-10">
            <Drawer.Handle className="h-1 w-1/3 mt-0 mb-3 rounded-full" />
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-text-secondary mb-1">
                  {isEdit ? "Edit" : "New"}
                </p>
                <h2 className="text-md font-bold text-text-primary">
                  {isEdit ? "Edit Price Alert" : "New Price Alert"}
                </h2>
              </div>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-4">
            <PriceAlertConfigFormContent
              config={config}
              onSubmit={onSubmit}
              isLoading={isLoading}
            />
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
